import React, { useState } from 'react';
import {
  Button, Dialog, DialogActions, DialogTitle, FormGroup, IconButton,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { HtmlTooltip } from 'components/tooltips/HtmlTootip';

function IconButtonDelete({
  onClick, dialogMessage, ...rest
}) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = (e) => {
    e.stopPropagation();
    setOpen(true);
  };

  const handleClose = (e) => {
    e?.stopPropagation();
    setOpen(false);
  };

  // eslint-disable-next-line react/no-unstable-nested-components
  function DeleteDialog() {
    return (
      <FormGroup>
        <Dialog open={open} onClose={handleClose} aria-labelledby="alert">
          <DialogTitle id="alert">{dialogMessage}</DialogTitle>
          <DialogActions style={{ padding: '0rem 1.5rem 1.5rem 0rem' }}>
            <Button
              variant="outlined"
              onClick={handleClose}
              style={{
                border: '1px solid red',
                color: 'red',
              }}
            >
              Não
            </Button>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                onClick();
                return handleClose();
              }}
              style={{
                backgroundColor: '#0267C1',
                color: 'white',
              }}
            >
              Sim
            </Button>
          </DialogActions>
        </Dialog>
      </FormGroup>
    );
  }

  return (
    <>
      <HtmlTooltip
        title="Apagar"
        placement="right"
        arrow
        interactive
      >
        <IconButton onClick={handleClickOpen} {...rest}>
          <DeleteIcon color="#545454" />
        </IconButton>
      </HtmlTooltip>
      {open && DeleteDialog()}
    </>
  );
}

export default IconButtonDelete;
